<template>
    <div class="vue timparty-featured-carousel featured-carousel">
      <LoaderOverlay v-if="loading"/>
      <div class="featured-carousel-arrows d-flex align-items-center"  v-if="images && images.length > 1">
          <div>
            <ArrowLeft class="box-arrow" @click="sliderGoto('prev')"/>
            <ArrowRight class="box-arrow" @click="sliderGoto()"/>
          </div>
        </div>
        <div class="featured-slider">
          <div class="slide bg-cover" v-for="image in images" v-bind:key="image"  :style="'background-image: url(' + image + ')'"></div>
          <div class="slide bg-cover bg-dark" v-if="images.length == 0" ></div>
        </div>
    </div>
</template>

<script>

    /* eslint-disable */ 

    import $ from 'jquery';
    import 'slick-carousel';

    import LoaderOverlay from './LoaderOverlay.vue'
    import ArrowLeft from '../assets/images/arrow-white-left.svg';
    import ArrowRight from '../assets/images/arrow-white-right.svg';


    export default {
      name: 'FeaturedCarousel',
      components: {
                    ArrowLeft,
                    ArrowRight,
                    LoaderOverlay,
                  },
      props: {
        images: [],
        
      },
      data: function(){

        return {
         
        };
      },
      mounted: function(){
          
          this.activateSlider();
      
      },
      
      methods: {
        activateSlider: function(){
          if( this.images.length > 1){
            this.$nextTick( function(){
              
              $('.featured-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
              });

            });
          }
        },

        sliderGoto: function(dir){

          if(dir == 'prev'){
            $('.featured-slider').slick('slickPrev');
          }
          else{
            $('.featured-slider').slick('slickNext');
          }
          
        }
      },
      watch: {
        images: function(new_val){
          if( new_val.length > 0)
            this.activateSlider();
        }
      }

      
    }
  </script>


